const Chart = ({ title, data, type = 'bar' }) => {
  if (type === 'bar') {
    const maxValue = Math.max(...data.map(d => d.value));
    
    return (
      <div className="bg-dark-card border border-gray-800 rounded-xl p-6">
        <h3 className="text-lg font-bold mb-4 text-white">{title}</h3>
        <div className="space-y-4">
          {data.map((item, index) => (
            <div key={index}>
              <div className="flex justify-between mb-2">
                <span className="text-sm text-gray-300">{item.label}</span>
                <span className="text-sm font-semibold text-toxic-green">{item.value}%</span>
              </div>
              <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden">
                <div
                  className="bg-gradient-to-r from-toxic-green to-green-400 h-3 rounded-full transition-all duration-500"
                  style={{ width: `${(item.value / maxValue) * 100}%` }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'pie') {
    const total = data.reduce((sum, item) => sum + item.value, 0);
    let currentAngle = 0;
    const colors = ['#39FF14', '#2ee00f', '#1fc00a', '#0fa005', '#0d8004'];
    
    return (
      <div className="bg-dark-card border border-gray-800 rounded-xl p-6">
        <h3 className="text-lg font-bold mb-4 text-white">{title}</h3>
        <div className="flex items-center justify-center mb-6">
          <svg width="200" height="200" viewBox="0 0 200 200" className="transform -rotate-90">
            {data.map((item, index) => {
              const percentage = (item.value / total) * 100;
              const angle = (percentage / 100) * 360;
              const largeArc = percentage > 50 ? 1 : 0;
              const x1 = 100 + 80 * Math.cos((currentAngle * Math.PI) / 180);
              const y1 = 100 + 80 * Math.sin((currentAngle * Math.PI) / 180);
              const x2 = 100 + 80 * Math.cos(((currentAngle + angle) * Math.PI) / 180);
              const y2 = 100 + 80 * Math.sin(((currentAngle + angle) * Math.PI) / 180);
              
              const pathData = [
                `M 100 100`,
                `L ${x1} ${y1}`,
                `A 80 80 0 ${largeArc} 1 ${x2} ${y2}`,
                `Z`
              ].join(' ');
              
              const color = colors[index % colors.length];
              currentAngle += angle;
              
              return (
                <path
                  key={index}
                  d={pathData}
                  fill={color}
                  className="transition-all duration-300 hover:opacity-80"
                />
              );
            })}
          </svg>
        </div>
        <div className="space-y-2">
          {data.map((item, index) => (
            <div key={index} className="flex items-center justify-between">
              <div className="flex items-center">
                <div
                  className="w-4 h-4 rounded mr-2"
                  style={{ backgroundColor: colors[index % colors.length] }}
                ></div>
                <span className="text-sm text-gray-300">{item.label}</span>
              </div>
              <span className="text-sm font-semibold text-toxic-green">{item.value}%</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === 'line') {
    const maxValue = Math.max(...data.map(d => d.value));
    const points = data.map((item, index) => {
      const x = (index / (data.length - 1)) * 100;
      const y = 100 - (item.value / maxValue) * 100;
      return `${x},${y}`;
    }).join(' ');

    return (
      <div className="bg-dark-card border border-gray-800 rounded-xl p-6">
        <h3 className="text-lg font-bold mb-4 text-white">{title}</h3>
        <div className="relative h-64">
          <svg width="100%" height="100%" viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute inset-0">
            <polyline
              points={points}
              fill="none"
              stroke="#39FF14"
              strokeWidth="0.5"
              className="transition-all duration-500"
            />
            <polygon
              points={`0,100 ${points} 100,100`}
              fill="url(#gradient)"
              opacity="0.2"
            />
            <defs>
              <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%">
                <stop offset="0%" stopColor="#39FF14" stopOpacity="1" />
                <stop offset="100%" stopColor="#39FF14" stopOpacity="0" />
              </linearGradient>
            </defs>
          </svg>
          <div className="absolute bottom-0 left-0 right-0 flex justify-between text-xs text-gray-500">
            {data.map((item, index) => (
              <span key={index}>{item.label}</span>
            ))}
          </div>
        </div>
        <div className="mt-4 space-y-2">
          {data.map((item, index) => (
            <div key={index} className="flex justify-between text-sm">
              <span className="text-gray-300">{item.label}</span>
              <span className="text-toxic-green font-semibold">{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return null;
};

export default Chart;

